import { ActividadService, ACTIVITY_SCREEN_OWN, ACTIVITY_SCREEN_ALL, ACTIVITY_SCREEN_MY_NETWORK } from '../../../services/actividad-service';
import { Component, OnInit, ViewChild, Output, EventEmitter, Input } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { FormControl } from '@angular/forms';
import { SearchService, SEARCH_TYPE_CUENTA, SEARCH_TYPE_COLABORADOR, SEARCH_TYPE_MOTOR } from '../../../services/search-service';
import { CuentasService } from '../../../services/cuentas-service';import { MdDialogRef, MdOptionSelectionChange, DateAdapter } from '@angular/material';
import * as moment from 'moment';

import { MotorAutocompleteComponent } from '../../../components/common/autocomplete';
import { CuentaEtiquetaAutocompleteComponent } from '../../../components/common/autocomplete';
import { ColaboradorAutocompleteComponent } from '../../../components/common/autocomplete';

@Component({
  selector: 'app-actividad-filter',
  templateUrl: './actividad-filter.component.html',
  styleUrls: ['./actividad-filter.component.scss']
})
export class ActividadFilterComponent implements OnInit {

  @Input() showFilters:boolean = false;
  public showConsignas = true;
  public showCuentas = true;
  public showPerfil = true;
  public showNegocios = true;
  @Input() screen: string;

  public startDate = moment().subtract(1,'week').toDate();
  public endDate = new Date();
  public minDate = moment(this.startDate).toDate();

  private wholeDay = false;

  @ViewChild('startDatePicker') startDatePicker;
  @ViewChild('endDatePicker') endDatePicker;
  @ViewChild(ColaboradorAutocompleteComponent) colaboradorAutocompleteComponent;
  @ViewChild(CuentaEtiquetaAutocompleteComponent) cuentaEtiquetaAutocompleteComponent;
  //@ViewChild(MotorAutocompleteComponent) motorAutocompleteComponent;

  @Output() onFiltersApplied = new EventEmitter();
  @Input() showColaboradorAutocomplete = true;

  @Output() filtersOpen = new EventEmitter<boolean>();

  constructor(private dateAdapter: DateAdapter<Date>,
              private cuentasService: CuentasService,
              private searchService: SearchService,
              private actividadService: ActividadService) {
    // Set datepicker locale to the one expected so it doesn't swap the day and
    // month when opening the calendar again, we hide the associated input anyways
    this.dateAdapter.setLocale('en-us');
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    /* Preload UI with last known filters applied */

    if ( (this.actividadService.actividadPropiaLastAppliedFilters && this.screen === ACTIVITY_SCREEN_OWN) ||
         (this.actividadService.actividadMiRedLastAppliedFilters && this.screen === ACTIVITY_SCREEN_MY_NETWORK) ||
         (this.actividadService.actividadTodosLastAppliedFilters && this.screen === ACTIVITY_SCREEN_ALL) ) {

      let filters;

      switch (this.screen){
        case ACTIVITY_SCREEN_OWN:
          filters = this.actividadService.actividadPropiaLastAppliedFilters;
          break;
        case ACTIVITY_SCREEN_MY_NETWORK:
          filters = this.actividadService.actividadMiRedLastAppliedFilters;
          break;
        case ACTIVITY_SCREEN_ALL:
          filters = this.actividadService.actividadTodosLastAppliedFilters;
          break;
        default: return;
      }

      this.showConsignas = filters.showConsignas;
      this.showCuentas = filters.showCuentas;
      this.showPerfil = filters.showPerfil;
      this.showNegocios = filters.showNegocios;
      this.startDate = filters.startDate;
      this.endDate = filters.endDate;
      this.cuentaEtiquetaAutocompleteComponent.selectedCuentas = filters.cuentas;
      this.cuentaEtiquetaAutocompleteComponent.selectedContactos = filters.contactos;
      this.colaboradorAutocompleteComponent.selectedColaboradores = filters.colaboradores;
      //this.motorAutocompleteComponent.selectedMotores = filters.motores;
    }
  }

  onApply(e){
    // dont hide the filter window when clicking the apply button
    e.stopPropagation();

    let startDate = this.startDate;
    let endDate = this.endDate;
    if (this.wholeDay) {
      startDate = moment(this.startDate).startOf('day').toDate();
      endDate = moment(this.endDate).endOf('day').toDate();
    }

    this.onFiltersApplied.emit({
      startDate: startDate,
      endDate: endDate,
      cuentas: this.cuentaEtiquetaAutocompleteComponent.selectedCuentas,
      contactos: this.cuentaEtiquetaAutocompleteComponent.selectedContactos,
      colaboradores: this.showColaboradorAutocomplete ? this.colaboradorAutocompleteComponent.selectedColaboradores : [],
      motores: [], //this.motorAutocompleteComponent.selectedMotores,
      showConsignas: this.showConsignas,
      showCuentas: this.showCuentas,
      showPerfil: this.showPerfil,
      showNegocios: this.showNegocios
    });
  }

  showStartDatePicker(){
    this.startDatePicker.open();
  }

  showEndDatePicker(){
    this.endDatePicker.open();
  }

  cleanFilters(e){
    // reset filters
    this.cuentaEtiquetaAutocompleteComponent.selectedCuentas = [];
    this.cuentaEtiquetaAutocompleteComponent.selectedContactos = [];
    //this.motorAutocompleteComponent.selectedMotores = [];

    if (this.showColaboradorAutocomplete) {
      this.colaboradorAutocompleteComponent.selectedColaboradores = [];
    }

    this.startDate = moment().subtract(1, 'week').toDate();
    this.endDate = new Date();
    this.minDate = moment(this.startDate).toDate();
    this.showConsignas = this.showPerfil = this.showCuentas = this.showNegocios = true;

    this.onApply(e);
  }

  toggleFilters() {
    this.showFilters = !this.showFilters;
    this.filtersOpen.emit(this.showFilters);
  }
}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/actividad/actividad-filter/actividad-filter.component.ts